<template>
  <v-dialog v-model="showModal" persistent max-width="500">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>
          <v-icon>info</v-icon>
            Sure you want to delete this user?
          </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="$emit('close-modal-delete-user')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <span class="subheading">Actually, you want to delete <strong>{{user.name}}</strong> from company <strong>{{user.client.name}}</strong>, once done you will not be able to restore it</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" flat @click="$emit('close-modal-delete-user')">No</v-btn>
        <v-btn color="green darken-1" flat @click="deleteUser">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object
    },
  },
  methods: {
    deleteUser () {
      this.$store.dispatch('setLoading', true);
      let url = '/users/' + this.user.id;
      window.axios.delete(url).then((response) => {
        this.$store.dispatch('setLoading', false);
        this.$store.dispatch('setSnackbar', {
          show: true,
          color: 'success',
          text: 'User deleted suscessfully'
        });
        this.$emit('update-users');
      });
    }
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/commons/users/modals/Delete.vue